import type { ClientChatMessage } from '@DigitaleDoerfer/digitale-doerfer-api';

const enum EntityName {
  Comment = 'de.fhg.iese.dd.platform.datamanagement.grapevine.model.Comment',
  Post = 'de.fhg.iese.dd.platform.datamanagement.grapevine.model.Post',
  Gossip = 'de.fhg.iese.dd.platform.datamanagement.grapevine.model.Gossip',
  NewsItem = 'de.fhg.iese.dd.platform.datamanagement.grapevine.model.NewsItem',
  Suggestion = 'de.fhg.iese.dd.platform.datamanagement.grapevine.model.Suggestion',
  Seeking = 'de.fhg.iese.dd.platform.datamanagement.grapevine.model.Seeking',
  Offer = 'de.fhg.iese.dd.platform.datamanagement.grapevine.model.Offer',
  Happening = 'de.fhg.iese.dd.platform.datamanagement.grapevine.model.Happening',
  Group = 'de.fhg.iese.dd.platform.datamanagement.grapevine.model.Group',
  SpecialPost = 'de.fhg.iese.dd.platform.datamanagement.grapevine.model.SpecialPost'
}

const isComment = (entityName?: string): boolean =>
  !!entityName && entityName === EntityName.Comment;

export const isCommentRef = (chatMessage: ClientChatMessage): boolean =>
  isComment(chatMessage.referencedEntityName);

const isGroup = (entityName?: string): boolean =>
  !!entityName && entityName === EntityName.Group;

export const isGroupRef = (chatMessage: ClientChatMessage): boolean =>
  isGroup(chatMessage.referencedEntityName);
